export const LIVESTREAM_TYPE_TIIVII_OTT = "tiivii-ott";
export const LIVESTREAM_TYPE_CUSTOM = "custom";

export const SERVICES_METADATA = {
  youtube: {
    name: "youtube",
    url: "rtmp://a.rtmp.youtube.com/live2",
    type: "youtube",
    description: "youtube",
  },
  facebook: {
    name: "facebook",
    url: "rtmps://live-api-s.facebook.com:443/rtmp/",
    type: "facebook",
    description: "facebook",
  },
  vimeo: {
    name: "vimeo",
    url: "rtmp://rtmp-global.cloud.vimeo.com/live",
    type: "vimeo",
    description: "vimeo",
  },
  [LIVESTREAM_TYPE_TIIVII_OTT]: {
    name: "tiivii-ott",
    url: "",
    type: "tiivii-ott",
    description: "tiivii-ott",
  },
  twitch: {
    name: "twitch",
    url: "rtmp://mad.contribute.live-video.net/app/",
    type: "twitch",
    description: "twitch",
  },
  dailymotion: {
    name: "dailymotion",
    url: "rtmp://publish.dailymotion.com/publish-dm",
    type: "dailymotion",
    description: "dailymotion",
  },
  [LIVESTREAM_TYPE_CUSTOM]: {
    name: "custom",
    url: "",
    description: "other cdn",
  },
};

export const STREAM_STATUS_DELETED = "deleted";

export const EVENT_PAGE_PARAM_NEW = "new";
